<template>  
  <div>
  <q-card inline style="width: 300px; background-color: transparent;">
  <q-card-section class="text-h6">
    {{$t('global.ExportTracks')}}
  </q-card-section>
  <q-card-section>
    <div class="row content">
      <div class="col-12">
        <q-select
          :label="$t('global.TrackingGroup')"
          v-model="trackingGroupSelected"
          :options="trackingGroupsOptions"
          emit-value map-options
        />
      </div>
    </div>  
    <div class="row content">
      <div class="col-12">
        <q-select
          label="Unit"
          v-model="deviceSelected"
          :options="deviceOptions"
          :disable="trackingGroupSelected == null"
          ref="device"
          map-options
        />
      </div>
    </div>  
    <div class="row content">
      <div class="col-12">
        <DateInput :date.sync="dateFrom" :label="$t('global.DateFrom')" style="padding: 10px;"></DateInput>
      </div>
    </div>
    <div class="row content">
      <div class="col-12">
        <DateInput :date.sync="dateTo" :label="$t('global.DateTo')" style="padding: 10px;"></DateInput>
      </div>
    </div>
    <div class="row content">
      <div class="col-12">
        <br>
        <q-btn color="primary"  
        :label="$t('global.ExportTracks')" 
        @click="trackExport" 
        :disable="trackingGroupSelected == null || deviceSelected == null"
        />
      </div>
    </div>  
  </q-card-section>
  <q-card-separator />
</q-card>   
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'ExportTrack',
  data () {
    return {
      form: {
        SessionId: null,
      },
      dateFrom: this.moment().add(-7, 'days'),
      dateTo: this.moment(),
      trackingGroupsOptions: [],
      trackingGroupSelected: null,
      deviceSelected: null,
      deviceOptions: []
    }
  },
  methods: {
    
    trackExport(){
      this.form.action = "PositionExport"
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.DateFrom = this.dateFrom.toISOString()
      this.form.DateTo = this.dateTo.toISOString()
      this.form.DeviceID = this.deviceSelected.value

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            if(response.data.length > 0){

              this.posExport(response.data)
              this.$q.notify({ message: response.data.length + ' Positions Exported', type: 'positive' })
            }
            else
              this.$q.notify('No data to export in this date range')
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e)
      })
    },
    loadTrackingGroups(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "TrackingGroupSelect"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.trackingGroupsOptions = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    posExport(positions){
    var poslist = ''
    positions.forEach(function (position, index) {
      console.log(index)
      console.log(position)
      poslist += ' ' + position.Longitude + ',' + position.Latitude
    })

    let kmlContent = "data:text/xml;charset=utf-8,"
    kmlContent += 
    `<kml xmlns="http://earth.google.com/kml/2.0">
    <Document>
      <name>Trackportal Data</name>
      <Folder>
        <name>Tracks</name>
        <Placemark>
          <name></name>
          <description>Unit: ${this.deviceSelected.label}, From: ${this.dateFrom.format(this.$store.state.session.DateFormat)}  To: ${this.dateTo.format(this.$store.state.session.DateFormat)}</description>
          <visibility>1</visibility>
          <LineString>
            <coordinates>
              ${poslist}
            </coordinates>
          </LineString>
        </Placemark>
      </Folder>
    </Document>
    </kml>`
          var data = encodeURI(kmlContent);
          var link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", "export.kml");
          document.body.appendChild(link)
          link.click();
    }   

  },
  created () {
    this.loadTrackingGroups()
  },
   watch: {
    trackingGroupSelected: function (newValue, oldValue) {  
      this.deviceSelected = null
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "DeviceSelect"
      this.form.TrackingGroupID = newValue
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.deviceOptions = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style>
</style>
